import MapLibreGL from "maplibre-gl";

const defaultAnimationOptions: MapLibreGL.AnimationOptions = {
    duration: 300
}

function locate(map: MapLibreGL.Map): GeolocationCoordinates | undefined {
    if (!("geolocation" in navigator)) {
        return undefined;
    }

    navigator.geolocation.getCurrentPosition(
        (pos) => {
            const { longitude, latitude } = pos.coords;

            map?.flyTo({
                center: [longitude, latitude],
                zoom: 14,
                duration: 1500,
            });

            return pos.coords;
        },
        (error) => {
            console.error("Error getting location:", error);
            return undefined;
        }
    );
}

function zoomIn(map: MapLibreGL.Map): void {
    map.zoomIn(defaultAnimationOptions);
}

function zoomOut(map: MapLibreGL.Map): void {
    map.zoomOut(defaultAnimationOptions);
}

function resetNorthPitch(map: MapLibreGL.Map): void {
    map.resetNorthPitch(defaultAnimationOptions);
}

function toggleFullscreen(map: MapLibreGL.Map): void {
    const container = map?.getContainer();
    if (!container) return;

    if (document.fullscreenElement) {
        document.exitFullscreen();
    } else {
        container.requestFullscreen();
    }
}

export default {
    locate,
    zoomIn,
    zoomOut,
    resetNorthPitch,
    toggleFullscreen
}